import jQuery, { parseJSON } from "jquery"
import { exception } from "vue-analytics"

export default class WholeSaler {
    constructor(app) {
        this.app = app

        this.isWholeSaler = false
        this.wholesaler_id = null
        this.version = "1.0"
        this.hookurl = null

        this.isAuthorized = false
        this.allowGuest = false
        this.allowAnonymous = false
        this.isGuestFormFilled = false
        this.isSending = false
    }

    config(params = {}) {
        var self = this
        Unex.log("Trying to config App with params", "WholeSaler")

        if (params.wholesaler_id == "test") {
            // Test WholeSaler:
            this.wholesaler_id = "test"
            this.isWholeSaler = true
            this.version = "1.0"
            this.hookurl =
                "https://testwholesaler.elbridge.itek.de/" +
                "TestOppositionWholesalerResponse.php?ID=" +
                parseInt(jQuery.now() / 1000)
            this.allowGuest = true
        } else if (params.wholesaler_id) {
            this.wholesaler_id = params.wholesaler_id
            this.isWholeSaler = true
            this.version = params.elbridge_version
            this.hookurl = params.hookurl
            this.allowGuest = params.allowGuest
            this.allowAnonymous = params.allowAnonymous
            if( params.allowUserdata ) {
                this.allowAnonymous = true
                // y aceptar condiciones
                this.app.acceptConditions(true)
            }
        }

        // TODO: get if guest is allowed

        // Tries to get data from sessionStorage
        this.getDataFromSessionStorage()

        // Post init
        if (this.isWholeSaler) {
            // Save info to sessionStorage
            Unex.log(
                "Saving wholesaler info to sessionStorage...",
                "Configurator"
            )

            this.saveDataToSessionStorage()

            // Check if user is logged in
            if (self.app.auth.isLogged == true) {
                self.isAuthorized = true
            }

            // Check if anonymous is allowed
            if (this.allowAnonymous == true) {
                self.isAuthorized = true
            }

            window.Unex.Authentication.on("login", function () {
                if (self.app.auth.isLogged == true) {
                    self.isAuthorized = true
                }
            })

            // Check if user filled the form
            if (this.allowGuest == true && this.isGuestFormFilled == true) {
                this.isAuthorized = true
            }
        } else {
            // Remove info from sessionStorage and so on
            // this.cleanData()
        }
    }

    /**
     * Tries to get data stored in sessionStorage in case has been lost in any redirection
     */
    getDataFromSessionStorage() {
        var storedData = this.app.getSettingFromStorage("WholeSaler")

        // Parse JSON
        if (storedData) {
            storedData = JSON.parse(storedData)

            Unex.log("Getting data from sessionStorage...", "Configurator")

            // HookUrl
            if (
                storedData &&
                (this.hookurl == null || this.hookurl == "") &&
                storedData.hookurl
            ) {
                this.hookurl = storedData.hookurl
                this.version = storedData.version
                this.allowGuest = storedData.allowGuest == true ? true : false
                // this.isGuestFormFilled = storedData.isGuestFormFilled == true ? true : false;
                this.isWholeSaler = true
            }
        }

        // Guest form filled
        var guestFormFilled = this.app.getSettingFromStorage("guestFormFilled")
        if (guestFormFilled == true || guestFormFilled == "true") {
            this.isGuestFormFilled = true
            if (this.allowGuest == true) {
                this.isAuthorized = true
            }
        }
    }
    saveDataToSessionStorage() {
        Unex.log("Saving data to sessionStorage...", "Configurator")

        this.app.saveSettingToStorage("WholeSaler", {
            wholesaler_id: this.wholesaler_id,
            version: this.version,
            hookurl: this.hookurl,
            allowGuest: this.allowGuest,
        })

        if (this.allowGuest) {
            this.app.saveSettingToStorage(
                "guestFormFilled",
                this.isGuestFormFilled
            )
        }
    }
    async showGuestForm() {
        var result = await Unex.CRM.Pardot.showForm(
            this.app.translate("browser_title_default"),
            "Configurator",
            "https://mkt.unex.net/l/876961/2023-04-18/n69yrr"
        )

        // TODO: remove
        // result = true

        if (result == true) {
            this.isAuthorized = true
            this.isGuestFormFilled = true
            this.saveDataToSessionStorage()
            this.app.acceptConditions(true)
        }
    }
    /***
     * TODO: Clean all wholesaler data
     */
    cleanData() {
        this.app.saveSettingToStorage("WholeSaler", null)
        this.app.saveSettingToStorage("guestFormFilled", null)
    }

    async sendToCart() {
        try {
            this.isSending = true
            var jsonData = await this.app.API.getElbridgeJSON()

            if (jsonData == null) {
                // Some error ocurred!
                // TODO: controlar...
                throw new exception("Error processing cart")
            }

            console.log("Version: ", this.version)
            console.log("JSON Data: ", jsonData)

            this.app.trackEvent("6_send_to_cart")
            // alert("Wait!");

            // Clean all data to avoid sending duplicate configuration to carts
            // TODO: if user goes back. say something?
            await this.app.createNewConfiguration()

            // Construct FORM to submit:
            var form = document.createElement("form")
            form.setAttribute("action", this.hookurl)
            form.setAttribute("method", "POST")
            if (Unex.isIFrame()) {
                form.setAttribute("target", "_top")
            }
            form.setAttribute("style", "display: none")

            var input1 = document.createElement("input")
            input1.setAttribute("type", "hidden")
            input1.setAttribute("name", "version")
            input1.setAttribute("value", this.version)

            var input2 = document.createElement("input")
            input2.setAttribute("type", "hidden")
            input2.setAttribute("name", "result")
            input2.setAttribute("value", jsonData)

            form.appendChild(input1)
            form.appendChild(input2)
            document.body.appendChild(form)
            form.submit()

            document.body.removeChild(form)
        } catch (error) {
            alert("An error ocurred processing the data")
            console.log(error)
        }
    }

    /**
     * Get domain from hookurl
     */
    getDomainFromHookUrl() {
        let domain = ""
        if (this.hookurl) {
            let url = new URL(this.hookurl)
            domain = url.hostname
        }
        return domain
    }
}
